<div class="container-fluid px-4">
  <div class="card mt-4">
    <div class="card-header">
      <h1 style="font-size:22px">{{japaneseLabel['supportSetting']}}</h1>

      <form (ngSubmit)="onSubmit()" #appSettingForm="ngForm" style="width: 80%;">
        <div class="mb-3">
          <label class="form-label">{{japaneseLabel['terms_of_serve']}}</label>
          <p class="form-label">{{japaneseLabel['display_terms_of_serve']}}</p>         
          <quill-editor
            [(ngModel)]="contentTerms"
            name="contentTerms"
            [style]="{ height: '200px', width: '100%' }"
          ></quill-editor>
        </div>

        <div class="mb-3">
          <label class="form-label">{{japaneseLabel['privacy_policy_settings']}}</label>
          <p class="form-label">{{japaneseLabel['display_privacy_policy_settings']}}</p>         
          <quill-editor
            [(ngModel)]="contentPrivacy"
            name="contentPrivacy"
            [style]="{ height: '200px', width: '100%' }"
          ></quill-editor>
        </div>

        <div class="mb-3">
          <label class="form-label">{{japaneseLabel['information']}}</label>
          <p class="form-label">{{japaneseLabel['display_information']}}</p>         
          <quill-editor
            [(ngModel)]="contentLaw"
            name="contentLaw"
            [style]="{ height: '200px', width: '100%' }"
          ></quill-editor>
        </div>

        <div class="mb-3">
          <label class="form-label">{{japaneseLabel['contact_settings']}}</label>
          <p class="form-label">{{japaneseLabel['display_contact_settings']}}</p>         
          <input
            type="text"
            class="form-control"
            name="contentUrl"
            [(ngModel)]="contentUrl"
            placeholder="URL"
          />
        </div>

        <!-- ✅ Submit Button -->
        <button type="submit" class="login-btn">
          {{japaneseLabel['submit_button']}}
        </button>
      </form>
    </div>
  </div>
</div>
